// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topology[data-v-1f7ac657] {\n  border-bottom: 1px solid #aaa;\n}", ""]);
// Exports
module.exports = exports;
